import { KeyOptionOrderEnum, KeySizePizzaEnum } from '~/utils/enum';

export interface ICommon {
  isTouchScreen: boolean;
}

export const initialState: ICommon = {
  isTouchScreen: false,
};
